var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Axios from 'axios';
import api from '../api';
import config from '@/config';
export var TaskflowBillingContext = React.createContext(null);
var TaskflowBillingProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), cache = _b[0], setCache = _b[1];
    useEffect(function () {
        var isMounted = true;
        var cancelToken = Axios.CancelToken.source();
        api.base
            .get("".concat(config.appUrls.api, "/api/InvoiceSchedule/TaskflowSubtasks"), {
            cancelToken: cancelToken.token,
        })
            .then(function (_a) {
            var data = _a.data;
            if (isMounted)
                setCache(data || {});
        }, function () {
            //Ignore errors
            if (isMounted)
                setCache({});
        });
        return function () {
            isMounted = false;
            if (cancelToken)
                cancelToken.cancel('Operation canceled due to new request.');
        };
    }, []);
    var hasTaskflowBilling = useCallback(function (invoiceScheduleId, subtaskTemplateId) {
        if (!cache || !invoiceScheduleId || !subtaskTemplateId)
            return false;
        var subtasks = cache[invoiceScheduleId];
        if (!subtasks)
            return false;
        return subtasks.indexOf(subtaskTemplateId) >= 0;
    }, [cache]);
    var value = useMemo(function () {
        return ({
            hasTaskflowBilling: hasTaskflowBilling,
        });
    }, [hasTaskflowBilling]);
    return (_jsx(TaskflowBillingContext.Provider, __assign({ value: value }, { children: children })));
};
export var useHasTaskflowBilling = function (invoiceScheduleId, subtaskTemplateId) {
    var ctx = useContext(TaskflowBillingContext);
    if (!ctx) {
        console.warn('TaskflowBillingContext not provided');
        return false;
    }
    return useMemo(function () { return ctx.hasTaskflowBilling(invoiceScheduleId, subtaskTemplateId); }, [
        invoiceScheduleId,
        subtaskTemplateId,
        ctx,
    ]);
};
export var withTaskflowBillingProvider = function (Component) { return function (_a) {
    var passThroughProps = __rest(_a, []);
    return (_jsx(TaskflowBillingProvider, { children: _jsx(Component, __assign({}, passThroughProps)) }));
}; };
